/** Order preserved: homepage carousel picks these from `CLIENT_TESTIMONIALS`. */
export const HOME_FEATURED_TESTIMONIAL_IDS = [
  'smit-gandhi',
  'rahul-vala',
  'santosh',
  'kuldip-gangdiya',
  'meet-soni'
];

export const HOME_TESTIMONIAL_TAGS_MAX = 3;
